<button
  #trigger="vsMenuTriggerFor"
  vs-button
  theme="default"
  appearance="outline"
  tooltipStyle="light"
  tooltipOpenDelay="400"
  class="h-5 w-5 !p-0 rounded-full absolute right-0 top-1 translate-x-[50%] z-20 shadow-none border-r-transparent border-b-transparent -rotate-45"
  [vsMenuPosition]="positions"
  [vsMenuTriggerFor]="descriptiveColumnsMenu"
  [vsTooltip]="{
    title: 'Add descriptive columns',
    subtitle:
      'Descriptive columns help track internal sales identifiers like SKUs and descriptions for better inventory management.',
  }"
>
  <vs-icon size="12" name="add-column" class="text-gray-500 h-3 w-3 rotate-45"></vs-icon>

  <ng-template #descriptiveColumnsMenu>
    <vs-menu>
      <div class="flex flex-col p-4 min-w-[300px]">
        <h3 class="text-sm font-semibold text-gray-700 mb-3">Add Descriptive Columns</h3>

        <div class="flex flex-col gap-3">
          <div
            *ngFor="let column of availableColumns"
            class="flex gap-3 px-3 py-2 rounded-lg hover:bg-gray-50 transition-all cursor-pointer"
            (click)="toggleColumn(column.key)"
          >
            <input
              vsInput
              type="checkbox"
              class="self-center cursor-pointer"
              [checked]="selectedColumns.includes(column.key)"
              (click)="$event.stopPropagation()"
            />
            <div class="flex flex-col">
              <p class="text-sm font-medium text-gray-700">{{ column.label }}</p>
              <p class="text-xs text-gray-500">{{ column.description }}</p>
            </div>
          </div>
        </div>

        <div class="flex gap-2 justify-between mt-4">
          <div class="flex gap-2 flex-wrap self-center">
            <div *ngFor="let column of selectedColumns" class="flex gap-1 max-h-[26px] border rounded-md px-2 py-1">
              <p class="text-xs font-medium text-gray-700">{{ getColumnName(column) }}</p>
              <button
                vs-button
                appearance="clear"
                class="!p-0.5 self-center max-h-[20px]"
                (click)="toggleColumn(column)"
              >
                <vs-icon name="x"></vs-icon>
              </button>
            </div>
          </div>

          <button vs-button theme="primary" [disabled]="selectedColumns.length === 0" (click)="addColumns()">
            Add Columns
          </button>
        </div>
      </div>
    </vs-menu>
  </ng-template>
</button>
